module.exports = __webpack_public_path__ + "static/media/qci_logo.10868432.png";